import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';

/**
 * Layout routes for protecting groups of routes based on user type.
 *
 * Usage:
 *   <Route element={<InternalRoute />}>
 *     <Route path="statements" element={<ReportsPage />} />
 *     <Route path="documents" element={<DocumentsPage />} />
 *   </Route>
 */

export const InternalRoute = ({redirectTo = '/shared'}) => {
  const {isExternalUser} = useSelector((state) => state.session);

  if (isExternalUser) {
    return <Navigate replace to={redirectTo} />;
  }

  return <Outlet />;
};

InternalRoute.propTypes = {
  redirectTo: PropTypes.string,
};

export const ExternalRoute = ({redirectTo = '/'}) => {
  const {isExternalUser} = useSelector((state) => state.session);

  if (!isExternalUser) {
    return <Navigate replace to={redirectTo} />;
  }

  return <Outlet />;
};

ExternalRoute.propTypes = {
  redirectTo: PropTypes.string,
};
